<div (click)="openReservation()" class="m-timeline-3__item" [ngClass]="classColor">
    <span class="m-timeline-3__item-time mf-list-title">
        <div class="text-uppercase mf-list-day mf-line-height mf-t-tleDanes">{{ dayName }}</div>
        <div class="mf-line-height mf-t-tleDate">{{ dateTime | date: 'dd. MM.' }}</div>
        <div class="mf-list-day mf-line-height mf-t-tleTime">{{ dateTime | date: 'HH:mm' }}</div>
    </span>
    <div class="m-timeline-3__item-desc">
        <span class="m-timeline-3__item-text">
            {{ primText | commTypeDescriptionPipe }}
        </span>
        <br />
        <span class="m-timeline-3__item-user-name">
            <div *ngFor="let sec of secText" class="m-timeline-3__item-link">
                <i class="{{ sec.icon }}"></i>
                {{ sec.text }}
            </div>
        </span>
    </div>
</div>
